if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        let activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) {
          activeMedia = this.querySelector('[data-media-id]');
          if (activeMedia) activeMedia.classList.add('active');
        }
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (activeMedia.tagName === 'IMG') {
          activeMedia.loading = 'eager';
          if (activeMedia.decode) activeMedia.decode().catch(() => {});
        }

        if (!window.matchMedia('(max-width: 749px)').matches) {
          activeMedia.scrollIntoView();
        }

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.clientWidth) {
          container.scrollLeft = (activeMedia.clientWidth - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
